/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ select: NonNullable<unknown>, of: NonNullable<unknown> }} Neat_Soft_Wasp_MendInputs */

const en_neat_soft_wasp_mend = /** @type {(inputs: Neat_Soft_Wasp_MendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.select} of ${i?.of} row(s) selected`)
};

const de_neat_soft_wasp_mend = /** @type {(inputs: Neat_Soft_Wasp_MendInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.select} von ${i?.of} Zeile(n) ausgewählt`)
};

/**
* | output |
* | --- |
* | "{select} of {of} row(s) selected" |
*
* @param {Neat_Soft_Wasp_MendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_soft_wasp_mend = /** @type {((inputs: Neat_Soft_Wasp_MendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Soft_Wasp_MendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_soft_wasp_mend(inputs)
	return de_neat_soft_wasp_mend(inputs)
});